export const textPt = [
  {
    text: 'Saiba mais',
    style: ['headerTitle'],
  },
  {
    text:
      'Este site foi pensado para professores de violoncelo de estudantes iniciantes de desenvolvimento instrumental que utilizam abordagens de ensino coletivo. É produto de uma pesquisa de mestrado realizada nos anos de 2017 e 2018 na Universidade de São Paulo, Brasil.',
    style: ['paragraph'],
  },
  {
    text:
      'Apesar do trabalho de pesquisa ter sido direcionado para estudantes de violoncelo, muitas das propostas contidas nos jogos podem ser desenvolvidas para outros instrumentos e, também, para outros níveis de aprendizagem, cabendo a cada professor fazer as adaptações que julgar necessárias e efetivas para suas demandas. Além disso, cabem muitos desdobramentos das propostas iniciais que podem suscitar outras ideias e perspectivas de trabalho.',
    style: ['paragraph'],
  },
  {
    text: 'Boa diversão e boas aprendizagens!',
    style: ['paragraph'],
  },
  {
    text: 'Sobre a autora',
    style: ['title'],
  },
  {
    text:
      "Marta Brietzke segurando seu violoncelo, ao fundo vê-se em desfoque o espelho d'agua do parque Farroupilha de Porto Alegre",
    style: ['picture'],
  },
  {
    text:
      'Meu nome é Marta Macedo Brietzke e sou natural de Porto Alegre, Rio Grande do Sul, Brasil. Iniciei meus estudos de música com meu pai e, logo após, no Projeto Prelúdio e na Orquestra Infanto-Juvenil da Universidade Federal do Rio Grande do Sul, com o violino e o violoncelo. Me graduei em Música nessa mesma universidade, fazendo minha pós-graduação em São Paulo, na Universidade de São Paulo.',
    style: ['paragraph'],
  },
  {
    text:
      'Atuei como instrumentista e como professora em orquestras e projetos sociais da capital e da região metropolitana do meu estado. Em conjunto com alguns estudantes de violoncelo, fundamos em Porto Alegre um espaço autogestionado de ensino e aprendizagem do violoncelo, denominado Filarmônica de Violoncelos-Tchêllistas. Minha área de pesquisa se relaciona ao ensino coletivo de instrumentos musicais abordando distintas possibilidades e facetas. Também me dedico à performance de música contemporânea de concerto, fazendo a estreia de algumas peças de compositores brasileiros.',
    style: ['paragraph'],
  },
]

export const textEn = [
  {
    text: 'About',
    style: ['headerTitle'],
  },
  {
    text:
      "This website is designed for cello teachers of beginning instrumental development students who use collective teaching approaches. It is the product of a master's research carried out in 2017 and 2018 at the University of São Paulo, São Paulo, Brazil.",
    style: ['paragraph'],
  },
  {
    text:
      'Although the research work was directed towards cello students, many of the proposals contained in the games can be developed for other instruments and also for other levels of learning, and it is up to each teacher to make the adaptations he or she deems necessary and effective for their demands. In addition, there are many developments of the initial proposals that can raise other ideas and work perspectives.',
    style: ['paragraph'],
  },
  {
    text: 'Have fun!',
    style: ['paragraph'],
  },
  {
    text: 'About the author',
    style: ['title'],
  },
  {
    text:
      'Marta Brietzke holding her cello, with the Farroupilha park from Porto Alegre in the background on blur.',
    style: ['picture'],
  },
  {
    text:
      'My name is Marta Macedo Brietzke and I am from Porto Alegre, Rio Grande do Sul, Brazil. I started my music studies with my father and, soon after, I participated in the Projeto Prelúdio and in the Orquestra Infanto-Juvenil of the Universidade Federal do Rio Grande do Sul, with violin and cello. I graduated in Music at the same university, doing my postgraduate studies in São Paulo, at the Universidade de São Paulo.',
    style: ['paragraph'],
  },
  {
    text:
      'I worked as an instrumentalist and as a teacher in orchestras and social projects in the capital and metropolitan region of my state. Together with some cello students, we founded a self-managed space for teaching and learning the cello in Porto Alegre, called Filarmônica de Violoncelos-Tchêllistas. My research area is related to the collective teaching of musical instruments, approaching different possibilities and facets. I also dedicate myself to the performance of contemporary concert music, making the premiere of some pieces by Brazilian composers.',
    style: ['paragraph'],
  },
]

export const textEs = [
  {
    text: 'Sepa más',
    style: ['headerTitle'],
  },
  {
    text:
      'Este sitio está diseñado para los profesores de violonchelo de alumnos principiantes que utilizan enfoques de enseñanza colectiva. Es producto de una investigación de maestría realizada durante los años 2017 y 2018 en la Universidad de São Paulo (São Paulo, Brasil).',
    style: ['paragraph'],
  },
  {
    text:
      'Apesar de que el trabajo de investigación fue dirigido para estudiantes principiantes de violoncello, muchas de las propuestas que se encuentran en estos juegos pueden ser desarrolladas para otros instrumentos y, también, para otros niveles de aprendizaje. Corresponde a cada profesor realizar las adaptaciones que considere necesarias y eficaces para sus demandas. Además, hay muchos desarrollos de las propuestas iniciales que pueden dar lugar a otras ideas y perspectivas de trabajo.',

    style: ['paragraph'],
  },
  {
    text: '¡Buena diversión y buen aprendizaje!',
    style: ['paragraph'],
  },
  {
    text: 'Sobre la autora',
    style: ['title'],
  },
  {
    text:
      'Marta Brietzke sosteniendo su violonchelo, al fondo se ve borroso el espejo de agua del Parque Farroupilha en Porto Alegre',
    style: ['picture'],
  },
  {
    text:
      'Mi nombre es Marta Macedo Brietzke y nací en Porto Alegre, Rio Grande do Sul, Brasil. Comencé mis estudios musicales con mi padre y, poco después, en el Proyecto Preludio y en la Orquesta Infantil y Juvenil de la Universidade Federal do Rio Grande do Sul, con violín y violonchelo. Me gradué en Música en la misma universidad, haciendo mi posgrado en São Paulo, en la Universidade de São Paulo.',
    style: ['paragraph'],
  },
  {
    text:
      'Actué como instrumentista y como profesora en orquestas y proyectos sociales en la capital y región metropolitana de mi estado. Junto con algunos estudiantes de violonchelo, fundamos en Porto Alegre un espacio autogestionado de enseñanza y aprendizaje de este instrumento, llamado Filarmônica de Violoncelos – Tchêllistas. Mi área de investigación está relacionada con la enseñanza colectiva de los instrumentos musicales, abordando diferentes posibilidades y facetas. También me dedico a la interpretación de música contemporánea de concierto, estrenando algunas piezas de compositores brasileños. ',
    style: ['paragraph'],
  },
]
